'use client'

import Lottie from 'lottie-react'

interface AnimatedIconProps {
  animationData: object
  height?: number
  width?: number
}

const AnimatedIcon = ({ animationData, height = 32, width = 32 }: AnimatedIconProps) => {
  return <Lottie animationData={animationData} loop={true} style={{ height, width }} />
}

export default AnimatedIcon
